import { groupBy } from 'lodash';

export default (state = [], action) => {
  switch (action.type) {
    case 'PROJECTS:SUCCESS': {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export const clusterAcronyms = {
  'The Treasury': 'The Treasury',
  Health: 'Health',
  Education: 'Education',
  Justice: 'Justice',
  'Premier and Cabinet': 'DPC',
  'Family and Community Services': 'FACS',
  Transport: 'Transport',
  'Finance, Services and Innovation': 'DFSI',
  Industry: 'Industry',
  'Planning and Environment': 'Planning and Environment',
};

export const getProjects = state => state;
export const getProjectsByCluster = state => {
  return groupBy(state, 'cluster');
};
export const getProjectsByPriority = state => {
  return groupBy(state, 'priority');
};
export const getBudgets = state => {
  return state.map(project => project.budget);
};
export const getProjectsByBudget = state => {
  return groupBy(state, project => {
    if (project.budget > 10000000) {
      return 'major';
    } else if (project.budget > 1000000 && project.budget <= 10000000) {
      return 'medium';
    } else if (project.budget > 0) {
      return 'small';
    } else return 'nobudget';
  });
};



// WEBPACK FOOTER //
// ./src/reducers/projects.js